// eslint-disable-next-line
export const errorMapper = (message: string, e: any) => {
  const rawMessage = e?.response?.data?.message

  const serverMessage =
    typeof rawMessage === 'string'
      ? rawMessage
      : Array.isArray(rawMessage)
      ? rawMessage[0]
      : rawMessage?.toString?.() ?? ''

  if (serverMessage.includes('already exists')) {
    return 'Пользователь с таким логином уже существует'
  }

  switch (serverMessage) {
    case 'name must be unique':
      return 'Имя должно быть уникальным'
    case 'phone must be unique':
      return 'телефон должен быть уникальным'
    case 'email must be unique':
      return 'email должен быть уникальным'
    case 'Not found task for this user pls check filter':
      return 'Нет текущих задач'
    case 'New base not found in this crm':
      return 'Нет новых баз данных'
    case 'Filter not found':
      return 'Нет фильтров для менеджера'
    case 'Please billing update':
      return 'Срок подписки на CRM окончен'
    case 'User is already online':
      return 'Пользователь уже залогинился'
    case 'Empty base':
      return 'В базе нет новых клиентов, выберите другую базу'
    case 'Zone not found':
      return 'Сервер не найден на cloudflare'
    case 'Z_BUF_ERROR':
      return 'Ошибка сервиса'
    case 'Crm not found':
      return 'CRM не подключена'
    case 'Crm are off':
      return 'CRM выключена'
    case 'Balance is not enough':
      return 'Недостаточно баланса. Обратитесь к администратору'
    case 'Tariff not found':
      return 'Тариф BROGO не настроен. Обратитесь к администратору'
    case 'Client not found':
      return 'Клиент не найден'
    case 'No available additional status names':
      return 'Достигнуто максимальное количество статусов'
    case 'Status not found':
      return 'Статуса нет в базе'
    case 'You can add in debt only once a month':
      return 'Кредит можно оформить только один раз в месяц'
    default:
      return message
  }
}
